function handleCollectionTabs() {
  const featuredCollections = document.querySelectorAll('.featured-collections');

  if (!featuredCollections.length) return;

  featuredCollections.forEach(section => {
    const buttons = section.querySelectorAll('.collection-tabs button');
    const tabSection = section.querySelector('.collection-tab-section');

    if (!buttons.length || !tabSection) return;

    buttons.forEach(button => {
      button.addEventListener('click', function () {
        buttons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');

        const targetId = this.dataset.id;
        if (!targetId) return;

        tabSection.querySelectorAll('slider-component').forEach(tab => {
          tab.classList.remove('is-selected');
        });

        const activeTab = tabSection.querySelector(`#tab-${targetId}`);

        if (activeTab) {
          activeTab.classList.add('is-selected');
        }
      });
    });
  });
}

function initFooterAccordion() {
  const mediaQuery = window.matchMedia('(max-width: 749px)');
  const footerBlocks = document.querySelectorAll('.footer-block--menu');

  footerBlocks.forEach((block) => {
    const heading = block.querySelector('.footer-block__heading');
    const content = block.querySelector('.footer-block__details-content');

    if (!heading || !content) return;

    const handleClick = () => {
      if (!mediaQuery.matches) return;

      block.classList.toggle('is-active');
    };

    heading.removeEventListener('click', handleClick);
    heading.addEventListener('click', handleClick);
  });
}

function initEditorialLookbookSlider() {
  const mediaQuery = window.matchMedia('(max-width: 749px)');
  const elems = document.querySelectorAll('.editorial-lookbook-image-wrapper');

  if (!elems.length || !mediaQuery.matches) return;

  elems.forEach(elem => {
    new Flickity(elem, {
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      pageDots: true,
      prevNextButtons: false
    });
  });
}

function multiColumnSlider() {
  let sections = document.querySelectorAll('.slider .multicolumn-list');

  if (!sections.length) return;

  sections.forEach(section => {
    if (section.classList.contains('flickity-enabled')) return;

    const slider = section.closest('.slider.multicolumn');

    if (
      slider?.classList.contains('mobile-only') &&
      window.innerWidth > 749
    ) {
      return;
    }

    new Flickity(section, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: slider?.classList.contains('pageDots'),
      prevNextButtons: false,
      groupCells: false,
      autoPlay: 2000
    });
  });
}

function blogSlider() {
  let sections = document.querySelectorAll('.featured--blog .articles-wrapper');

  if (!sections.length) return;

  sections.forEach(section => {
    if (section.classList.contains('flickity-enabled')) return;

    if (window.innerWidth > 749) {
      return; 
    }

    new Flickity(section, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      groupCells: false,
      autoPlay: 2000
    });
  });
}

class TestimonialSlider {
  constructor(section) {
    this.section = section;
    this.slides = section.querySelectorAll('.testimonial-slide');
    this.prevBtn = section.querySelector('.prev');
    this.nextBtn = section.querySelector('.next');

    if (this.slides.length <= 1) return;

    this.current = 0;
    this.interval = null;

    this.init();

    this.stopAutoplay();
  }

  init() {
    this.bindEvents();
    this.startAutoplay();
  }

  bindEvents() {
    this.nextBtn?.addEventListener('click', () => {
      this.next();
      this.restartAutoplay();
    });

    this.prevBtn?.addEventListener('click', () => {
      this.prev();
      this.restartAutoplay();
    });

    this.section.addEventListener('mouseenter', () => {
      this.stopAutoplay();
    });

    this.section.addEventListener('mouseleave', () => {
      this.startAutoplay();
    });
  }

  show(index) {
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });
  }

  next() {
    this.current = (this.current + 1) % this.slides.length;
    this.show(this.current);
  }

  prev() {
    this.current =
      (this.current - 1 + this.slides.length) % this.slides.length;
    this.show(this.current);
  }

  startAutoplay() {
    this.interval = setInterval(() => {
      this.next();
    }, 5000);
  }

  stopAutoplay() {
    clearInterval(this.interval);
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}


document.addEventListener('DOMContentLoaded', function(){
  initFooterAccordion();
  handleCollectionTabs();
  initEditorialLookbookSlider();
  multiColumnSlider();
  blogSlider();

  const sections = document.querySelectorAll('.customer-testimonials-section');

  if (sections.length) {
    sections.forEach((section) => {
      new TestimonialSlider(section);
    });
  }
});